import { useTranslation } from "gatsby-plugin-react-i18next";

import { formatCurrency } from "../../utils/i18n/format";
import { GalleryMain } from "./Gallery";
import { useState } from "react";
import SellBuyDecisionDivider from "../Hero/SellBuyDecisionDivider";
import { BUYING_CATALOG_ROUTE, SELLING_SEARCH_ROUTE } from "../../utils/routes/const";
import ArrowButton from "../Atoms/ArrowButton";
import Link from "../Atoms/Link";

const SeoWatchHeader = ({ seoWatch }: { seoWatch: WatchProject21Api.SeoWatch }) => {
  const { watch } = seoWatch;
  const { t } = useTranslation();
  const [activeImage, setActiveImage] = useState(0);
  const [, setIsThreesixtyImagesViewOpen] = useState(false);

  const sellingLink = `${SELLING_SEARCH_ROUTE}?brand[]=${watch.brand.name}&model[]=${watch.model?.name || ''}`;
  const buyingLink = `${BUYING_CATALOG_ROUTE("")}?brandName=${watch.brand.name}&modelName=${watch.model?.name || ''}`;

  return (
    <section className="max-w-10xl mx-auto py-28 lg:py-44 flex flex-col">
      <div className="flex flex-col lg:flex-row">
        <GalleryMain
          salesWatch={seoWatch}
          setActiveImage={setActiveImage}
          activeImage={activeImage}
          setIsThreesixtyImagesViewOpen={setIsThreesixtyImagesViewOpen}
        />
        <div className="lg:w-3/5 lg:py-18 lg:pl-32 py-9 lg:pr-16 mb-2 lg:mb-0 flex flex-col lg:bg-white text-center lg:text-left">
          <h1>
            <span className="block font-cirka font-bold text-xl mb-2 lg:mb-5">{watch.brand.name}</span>
            <span className="block font-cirka text-3xl mb-4">{watch.model?.name} {seoWatch.additionalTitle || ''}</span>
          </h1>
          <p className="font-bold mt-4">{seoWatch.priceOnDemand ? t('general.priceOnDemand') : formatCurrency(seoWatch.price)}</p>
          <p className="text-xs mb-4">{t('seoWatch.availableOnDemand')}</p>
          <dl className="lg:columns-2">
            {watch.referenceNumber && (
              <><dt className="my-1 text-sm lg:text-md"><b>{t('general.referenceNumber')}</b></dt><dd className="mb-4 text-sm lg:text-md">{watch.referenceNumber}</dd></>
            )}
            {watch.brand?.name && (
              <><dt className="my-1 text-sm lg:text-md"><b>{t('general.brand')}</b></dt><dd className="mb-4 text-sm lg:text-md">{watch.brand.name}</dd></>
            )}
            {watch.model?.name && (
              <><dt className="my-1 text-sm lg:text-md"><b>{t('general.model')}</b></dt><dd className="mb-4 text-sm lg:text-md">{watch.model.name}</dd></>
            )}
            {seoWatch.movement && (
              <><dt className="my-1 text-sm lg:text-md"><b>{t('general.movement')}</b></dt><dd className="mb-4 text-sm lg:text-md">{t('general.movement.' + seoWatch.movement)}</dd></>
            )}
            {seoWatch.boxMaterial && (
              <><dt className="my-1 text-sm lg:text-md"><b>{t('general.boxMaterial')}</b></dt><dd className="mb-4 text-sm lg:text-md">{seoWatch.boxMaterial}</dd></>
            )}
            {seoWatch.wristbandMaterial && (
              <><dt className="my-1 text-sm lg:text-md"><b>{t('general.wristbandMaterial')}</b></dt><dd className="mb-4 text-sm lg:text-md">{seoWatch.wristbandMaterial}</dd></>
            )}
            {seoWatch.diameter && (
              <><dt className="my-1 text-sm lg:text-md"><b>{t('general.diameter')}</b></dt><dd className="mb-4 text-sm lg:text-md">{seoWatch.diameter}</dd></>
            )}
            {seoWatch.productionYear && (
              <><dt className="my-1 text-sm lg:text-md"><b>{t('general.productionYear')}</b></dt><dd className="mb-4 text-sm lg:text-md">{(new Date(seoWatch.productionYear)).getFullYear()}</dd></>
            )}
            {seoWatch.watchCondition && (
              <><dt className="my-1 text-sm lg:text-md"><b>{t('general.watchCondition')}</b></dt><dd className="mb-4 text-sm lg:text-md">{t('general.watchCondition.' + seoWatch.watchCondition)}</dd></>
            )}
            {seoWatch.gender && (
              <><dt className="my-1 text-sm lg:text-md"><b>{t('general.gender')}</b></dt><dd className="mb-4 text-sm lg:text-md">{t('general.gender.' + seoWatch.gender)}</dd></>
            )}
            {seoWatch.location && (
              <><dt className="my-1 text-sm lg:text-md"><b>{t('general.location')}</b></dt><dd className="mb-4 text-sm lg:text-md">{seoWatch.location}</dd></>
            )}
          </dl>
          <Link to={`/checkout?seoWatchId=${seoWatch.seoWatchId}`} className="flex items-center justify-center lg:justify-start mt-5 lg:my-5 no-animation">
            <ArrowButton isGhost={false} className="h-10 mr-5" imgClass="h-10" />
            {t('general.buy')}
          </Link>
        </div>
      </div>
      <div className="order-4 py-10 px-4 lg:px-36">
        <h2 className="font-bold">{t('pdp.description')}</h2>
        <hr className="my-2 lg:my-4" />
        <div className="text-sm lg:text-md" dangerouslySetInnerHTML={{ __html: seoWatch.description }} />
      </div>
      <div className="order-5 py-10 px-4 lg:px-36">
        <SellBuyDecisionDivider
          t={t}
          sellingLink={sellingLink}
          buyingLink={buyingLink}
          wrapperClassName="flex text-center flex-col items-center justify-center"
        />
      </div>
    </section>
  );
}

export default SeoWatchHeader;
